import {
  SET_EWALLET_INDIVIDUAL_REPORT_DATA,
  SET_EWALLET_POPUP_REPORT_DATA,
  SET_EWALLET_REPORT_DATA,
  SET_REPORT_LIST_DATA,
  SET_VISITOR_HISTORY_LIST_DATA,
} from '../../../store/types'
import Vue from 'vue'

export default {
  [SET_REPORT_LIST_DATA](state, payload) {
    Vue.set(state.reportsList, 'list', payload.list)
  },
  [SET_EWALLET_REPORT_DATA](state, payload) {
    if (payload !== undefined) {
      Vue.set(state.eWalletReport, 'data', payload.data)
      Vue.set(state.eWalletReport, 'columns', payload.columns)
    } else {
      Vue.set(state.eWalletReport, 'data', [])
      Vue.set(state.eWalletReport, 'columns', [])
    }
  },
  [SET_EWALLET_POPUP_REPORT_DATA](state, payload) {
    if (payload !== undefined) {
      Vue.set(state.eWalletPopupReport, 'data', payload.data)
      Vue.set(state.eWalletPopupReport, 'columns', payload.columns)
    } else {
      Vue.set(state.eWalletPopupReport, 'data', [])
      Vue.set(state.eWalletPopupReport, 'columns', [])
    }
  },
  [SET_EWALLET_INDIVIDUAL_REPORT_DATA](state, payload) {
    if (payload !== undefined) {
      Vue.set(state.eWalletIndividualReport, 'data', payload.data)
      Vue.set(state.eWalletIndividualReport, 'columns', payload.columns)
    } else {
      Vue.set(state.eWalletIndividualReport, 'data', [])
      Vue.set(state.eWalletIndividualReport, 'columns', [])
    }
  },
  [SET_VISITOR_HISTORY_LIST_DATA](state, payload) {
    Vue.set(state.visitorHistoryList, 'list', payload.list)
  },
}
